import { usePage } from "@inertiajs/react"
import { UserLayout } from "@/components/layouts/user-layout"
import { DishDetail } from "@/features/user/dish-detail"
import type { DinerSummary, ItemDetail } from "@/features/user/types"

type Props = {
  diner: DinerSummary
  item: ItemDetail
}

export default function UserItemsShow() {
  const { diner, item } = usePage<Props>().props

  return (
    <UserLayout wide>
      <DishDetail
        item={item}
        billId={diner?.billId ?? null}
        serviceContext={diner?.serviceContext}
      />
    </UserLayout>
  )
}
